import React, { useEffect, useState, useContext, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import CustomGrid from "../../components/common/CustomGrid/CustomGrid";
import { fetchSitesDetailData } from "../../redux/slice/SitesSlice/SitesSlice";
import Loader from "../Loader/Loader";
import { BreadcrumbsContext } from "../../context/BcrumbsContextProvider";
import * as XLSX from "xlsx";
import {
  CreateExcelApi,
  CreateEquipmentWorkingExcel,
  CreateComponentWorkingExcel,
} from "../../Apis/Sites/SitesApis";
import { SnackBarContext } from "../../context/SnackBarContext";
import { FaTrash } from "react-icons/fa";

function SitesView() {
  const dispatch = useDispatch();
  const { SitesDetail, status } = useSelector((state) => state?.Sites);
  const [filterData, setFilterData] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [fileName, setFileName] = useState("");
  const [loading, setLoading] = useState(false); // Added loading state
  const location = useLocation();
  const data = location.state?.data;
  const type = location.state?.type;
  console.log("these are types", type);
  const { setBreadcrumbsItems } = useContext(BreadcrumbsContext);
  const { setsnackBarData } = useContext(SnackBarContext);
  const [columns, setColumns] = useState([]);

  const fileInputRef = useRef(null);

  const handleBreadcrumbs = () => {
    setBreadcrumbsItems([
      {
        id: 1,
        url: "/sites",
        name: "Sites",
      },
      {
        id: 2,
        url: "/sites/sites-view",
        name: "Sites View",
      },
    ]);
  };

  useEffect(() => {
    handleBreadcrumbs();
    return () => {
      setBreadcrumbsItems([]);
    };
  }, [setBreadcrumbsItems]);

  useEffect(() => {
    dispatch(fetchSitesDetailData({ id: data, type: type }));
  }, [dispatch, data]);

  useEffect(() => {
    // let sourceData = [];

    // if (type === "equipment") {
    //   sourceData = SitesDetail;
    // } else if (type === "equipmentWorking") {
    //   sourceData = SiteDetail2;
    // } else if (type === "componentWorking") {
    //   sourceData = SiteDetail3;
    // }

    const arr =
      SitesDetail?.map((item, idx) => ({
        idx: idx + 1,
        ...item,
      })) || [];

    setFilterData(arr);
  }, [SitesDetail]);

  const columnsEqu = [
    {
      Header: "Sr.",
      accessor: "idx",
      minWidth: 100,
      width: 120,
    },
    {
      Header: "Unit #",
      accessor: "unitNumber",
      minWidth: 100,
      width: 120,
    },
    {
      Header: "Equipment #",
      accessor: "equipmentNumber",
      minWidth: 120,
      width: 140,
    },
    {
      Header: "Serial #",
      accessor: "serialNumber",
      minWidth: 100,
      width: 120,
    },
    {
      Header: "Description",
      accessor: "description",
    },
    {
      Header: "EQUIP TYPE",
      accessor: "equipType",
      minWidth: 100,
      width: 120,
    },
    {
      Header: "P&ID",
      accessor: "pAndId",
      minWidth: 120,
    },
    {
      Header: "National BD. #",
      accessor: "nationalBdNumber",
      minWidth: 150,
    },
    {
      Header: "Insulated",
      accessor: "insulated",
      minWidth: 100,
      width: 120,
    },
    {
      Header: "Design Pressure",
      accessor: "designPressure",
      minWidth: 150,
    },
    {
      Header: "Design Temp.",
      accessor: "designTemp",
      minWidth: 150,
    },
    {
      Header: "OPER. Pressure",
      accessor: "operPressure",
      minWidth: 150,
    },
    {
      Header: "OPER. Temp.",
      accessor: "operTemp",
      minWidth: 120,
    },
    {
      Header: "Year Built",
      accessor: "yearBuilt",
      minWidth: 100,
    },
    {
      Header: "WBS Code",
      accessor: "wbsCode",
      minWidth: 100,
    },
    {
      Header: "WSP #",
      accessor: "wspNumber",
      minWidth: 100,
    },
    {
      Header: "PWHT",
      accessor: "pwht",
      minWidth: 100,
    },
    {
      Header: "Required Test Pressure SS",
      accessor: "requiredTestPressureSS",
      minWidth: 150,
    },
    {
      Header: "Required Hold Time SS",
      accessor: "requiredHoldTimeSS",
      minWidth: 150,
    },
    {
      Header: "Required Test Medium SS",
      accessor: "requiredTestMediumSS",
      minWidth: 150,
    },
    {
      Header: "Required Test Pressure TS",
      accessor: "requiredTestPressureTS",
      minWidth: 150,
    },
    {
      Header: "Required Hold Time TS",
      accessor: "requiredHoldTimeTS",
      minWidth: 150,
    },
    {
      Header: "Required Test Medium TS",
      accessor: "requiredTestMediumTS",
      minWidth: 150,
    },
  ];

  const columnsCompWork = [
    { Header: "Sr.", accessor: "idx", minWidth: 120 },
    { Header: "CONCATENATE", accessor: "concatenate", minWidth: 120 },
    { Header: "EQUIPID", accessor: "equipmentNumber", minWidth: 120 },
    { Header: "SUBGROUP", accessor: "subGroup", minWidth: 120 },
    { Header: "UNITID", accessor: "unitNumber", minWidth: 120 },
    { Header: "COMPONENID", accessor: "compId", minWidth: 140 },
    { Header: "COMPMASTER", accessor: "compMaster", minWidth: 140 },
    { Header: "DIVISION", accessor: "division", minWidth: 120 },
    { Header: "DESCRIPTION", accessor: "description", minWidth: 150 },
    { Header: "ORIGTHICK", accessor: "orgThickness", minWidth: 130 },
    { Header: "INNERDIAM", accessor: "innerDiameter", minWidth: 130 },
    { Header: "OUTERDIAM", accessor: "outerDiameter", minWidth: 130 },
    { Header: "JOINTEFF", accessor: "jointEfficiency", minWidth: 120 },
    { Header: "INSERVDT", accessor: "yearBuilt", minWidth: 140 },
    {
      Header: "REFRENCE MATEIRAL",
      accessor: "refMaterial",
      minWidth: 180,
    },
    { Header: "PCODE", accessor: "pCode", minWidth: 120 },
    { Header: "MAX TENSILE", accessor: "maxTensile", minWidth: 140 },
    { Header: "MIN TENSILE", accessor: "minTensile", minWidth: 140 },
    { Header: "CODESIGNP", accessor: "codeSignPressure", minWidth: 140 },
    { Header: "CODESIGNT", accessor: "codeSignTemperature", minWidth: 140 },
    { Header: "ORGCORALOW", accessor: "orgCorAllow", minWidth: 150 },
    { Header: "HEADGEOM", accessor: "headGeom", minWidth: 140 },
    { Header: "HMINORAXIS", accessor: "hMAxis", minWidth: 140 },
    { Header: "APEXANGLE", accessor: "apexAngle", minWidth: 140 },
    { Header: "KNUCKLERAD", accessor: "knuckleRad", minWidth: 150 },
    { Header: "CROWNIRAD", accessor: "crownInnerRad", minWidth: 150 },
    { Header: "CROWNORAD", accessor: "crownOuterRad", minWidth: 150 },
    { Header: "REGULARHED", accessor: "regularHead", minWidth: 150 },
    { Header: "SERIALNO", accessor: "serialNumber", minWidth: 140 },
    { Header: "REGISTRNO", accessor: "regNumber", minWidth: 140 },
    { Header: "PWHT", accessor: "pwht", minWidth: 120 },
    { Header: "FULLVAC", accessor: "fullVac", minWidth: 120 },
    { Header: "MAWP", accessor: "mawP", minWidth: 130 },
    { Header: "MAWT", accessor: "mawT", minWidth: 130 },
    { Header: "MDMTEMP", accessor: "mdmTemperature", minWidth: 140 },
    { Header: "FLANGE RATING", accessor: "flangeRating", minWidth: 160 },
    { Header: "LOCATION", accessor: "location", minWidth: 140 },
    { Header: "BASE METAL THKNS", accessor: "baseMetalThick", minWidth: 180 },
    { Header: "REPAD THKNS", accessor: "repadThick", minWidth: 160 },
    { Header: "REPAD WIDTH", accessor: "repadWidth", minWidth: 160 },
    {
      Header: "REPAD FILLET WELD SIZE",
      accessor: "repadFilletWeldSize",
      minWidth: 200,
    },
    {
      Header: "NOZ FILLET WELD SIZE",
      accessor: "nozFilletWeldSize",
      minWidth: 200,
    },
  ];

  const columnsEquWork = [
    {
      Header: "Sr.",
      accessor: "idx",
      minWidth: 100,
      width: 120,
    },
    { Header: "EQUIPID", accessor: "equipmentNumber", minWidth: 120 },
    { Header: "SUBGROUP", accessor: "subGroup", minWidth: 120 },
    { Header: "UNITID", accessor: "unitNumber", minWidth: 120 },
    { Header: "P&ID", accessor: "pAndId", minWidth: 120 },
    { Header: "DESCRIPT", accessor: "description", minWidth: 150 },
    { Header: "DESIGNPRES", accessor: "designPressure", minWidth: 140 },
    { Header: "DESIGNTEMP", accessor: "designTemp", minWidth: 140 },
    { Header: "DIVISION", accessor: "division", minWidth: 120 },
    { Header: "REGISTRNO", accessor: "regNumber", minWidth: 140 },
    { Header: "SERIALNO", accessor: "serialNumber", minWidth: 140 },
    { Header: "INSERVICDT", accessor: "yearBuilt", minWidth: 150 },
    { Header: "CORRALLOW", accessor: "corrAllow", minWidth: 130 },
    { Header: "FULLVAC", accessor: "fullVac", minWidth: 120 },
    { Header: "PWHT", accessor: "pwht", minWidth: 120 },
    { Header: "ORIENT", accessor: "orient", minWidth: 120 },
    { Header: "EQHEIGHT", accessor: "eqHeight", minWidth: 140 },
    { Header: "SUPPTYPE", accessor: "SupType", minWidth: 130 },
    { Header: "MDMTEMP", accessor: "mdmTemp", minWidth: 140 },
    { Header: "PSV SET PRES", accessor: "setPressure", minWidth: 150 },
    { Header: "COMMENTS", accessor: "comment", minWidth: 180 },
    { Header: "WHAT IS THE Gap", accessor: "gap", minWidth: 180 },
    { Header: "DATA PLATE", accessor: "data", minWidth: 150 },
  ];

  const exportToExcel = () => {
    if (!columns || columns.length === 0) return;

    const filteredColumns = columns.slice(1);
    const headers = filteredColumns.map((column) => column.Header);
    const ws = XLSX.utils.aoa_to_sheet([headers]);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sites Data");
    XLSX.writeFile(wb, "SitesData.xlsx");
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];

    if (!file) {
      setSelectedFile(null);
      setFileName("");
      return;
    }
    setSelectedFile(file);
    setFileName(file.name);
    e.target.value = "";
  };

  const handleUploadClick = () => {
    fileInputRef.current.click();
  };

  const handleUploadSubmit = async () => {
    if (selectedFile) {
      setLoading(true);
      const formData = new FormData();
      formData.append("excelfile", selectedFile);
      formData.append("jobsiteId", data);
      try {
        let response = "";
        if (type === "equipment") {
          response = await CreateExcelApi(formData);
        } else if (type === "equipmentWorking") {
          response = await CreateEquipmentWorkingExcel(formData);
        } else if (type === "componentWorking") {
          response = await CreateComponentWorkingExcel(formData);
        }

        if (response && response.success) {
          dispatch(fetchSitesDetailData({ id: data, type: type }));
          setsnackBarData({
            openToast: true,
            type: response.snackBarData?.type || "success",
            message: response.msg || "File uploaded successfully.",
          });
        } else {
          setsnackBarData({
            openToast: true,
            type: "error",
            message: response?.msg || "Failed to upload the file.",
          });
        }
      } catch (error) {
        console.error("Error uploading file:", error);
        setsnackBarData({
          type: "error",
          message: "Error uploading file.",
          openToast: true,
        });
      } finally {
        setLoading(false);
        setSelectedFile(null);
        setFileName("");
        fileInputRef.current.value = "";
      }
    } else {
      setsnackBarData({
        type: "error",
        message: "Please select a file to upload.",
        openToast: true,
      });
    }
  };

  const handleClearFile = () => {
    setSelectedFile(null);
    setFileName("");
    fileInputRef.current.value = "";
  };

  useEffect(() => {
    if (type === "equipment") {
      setColumns(columnsEqu);
    } else if (type === "equipmentWorking") {
      setColumns(columnsEquWork);
    } else if (type === "componentWorking") {
      setColumns(columnsCompWork);
    } else {
      setColumns(columnsEqu);
    }
  }, [type]);

  return (
    <>
      <div className="mb-2 d-flex justify-content-between align-items-center">
        <button
          className="btn btn-primary"
          style={{ marginRight: "20px" }}
          onClick={exportToExcel}
          disabled={loading}
        >
          Extract to Excel
        </button>
        <div className="d-flex gap-2" style={{ justifyContent: "flex-end" }}>
          <input
            type="file"
            accept=".xlsx, .xls"
            onChange={handleFileChange}
            style={{ display: "none" }}
            ref={fileInputRef}
          />
          <button
            className="btn btn-secondary"
            onClick={handleUploadClick}
            disabled={loading}
          >
            Upload Excel File
          </button>
          <button
            className="btn btn-primary"
            onClick={handleUploadSubmit}
            disabled={loading || selectedFile == null}
          >
            Submit
          </button>
        </div>
      </div>
      {fileName && (
        <div
          className="mb-3 d-flex  gap-2"
          style={{
            textAlign: "right",
            justifyContent: "end",
            alignItems: "center",
          }}
        >
          <strong>Selected File:</strong>
          <button type="button" className="btn btn-secondary">
            {fileName}
          </button>
          <button
            aria-label="clear"
            onClick={handleClearFile}
            size="small"
            style={{ marginLeft: "8px" }}
          >
            <FaTrash />
          </button>
        </div>
      )}
      {status === "loading" || loading ? (
        <div className="text-center">
          <Loader />
        </div>
      ) : (
        <div>
          <p style={{ fontWeight: 600, marginTop: "5px" }}>
            {type === "equipment"
              ? "Equipment Detail"
              : type === "equipmentWorking"
                ? "Equipment Working Detail"
                : type === "componentWorking"
                  ? "Component Working Detail"
                  : "Sites Detail"}
          </p>
          <CustomGrid columns={columns} data={filterData} />
        </div>
      )}
    </>
  );
}

export default SitesView;
